import type { IUser } from '@manager/api/types/auth-types';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const publicApiRoutes: RouteMetaConfig[] = [
  {
    path: '/public-api',
    name: routeNames.publicApi,
    component: () => import('./views/PublicApiListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'tenant_api_keys.view',
      additionalCheck: (user: IUser) =>
        user.tenant_features.has_public_api_enabled,
      listFilterName: 'public-api-keys',
    },
  },
];
